import axios from 'axios'
import Qs from 'qs'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'

axios.defaults.headers.post['Content-Type'] = 'application/json'

export const ReachAPI = createAuthedHttpClient({
  baseConfig: { baseURL: config.REACH_API },
})

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const AccountsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNTS_API,
  },
})

export const FileAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FILE_API,
  },
})

export const AudienceDiscoveryAPI = createAuthedHttpClient({
  baseConfig: { baseURL: config.AUDIENCE_DISCOVERY_API },
})

export const PropertyDefinitionsAPI = createAuthedHttpClient({
  baseConfig: { baseURL: config.PROPERTY_DEFINITIONS_API },
})
